module.exports = __webpack_public_path__ + "static/img/home.b5620a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn/home.png
// module id = iLWX
// module chunks = 1